import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  appEnvironmentConfig,
  bankIdTestIndexConfig,
  intelligentServicesApiConfig,
} from '../../IntelligentServicesConfig';

const dynamicBaseQuery: ReturnType<typeof fetchBaseQuery> = (
  args,
  api,
  extraOptions
) => {
  const latestBaseUrl = intelligentServicesApiConfig.baseUrl;
  const rawBaseQuery = fetchBaseQuery({ baseUrl: latestBaseUrl });
  return rawBaseQuery(args, api, extraOptions);
};

export const intelligentServicesApi = createApi({
  reducerPath: 'intelligentServicesApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getBankIdSession: builder.query<string, string>({
      query: (sessionId: string) => {
        const isTest = appEnvironmentConfig() !== 'production';
        const configuredTestIndex = bankIdTestIndexConfig();
        const parsed = Number(configuredTestIndex);
        const testIndex = Number.isFinite(parsed) ? Math.trunc(parsed) : 26;
        return `/get_session_v2?grandidsession=${sessionId}${
          isTest ? `&test=true&testIndex=${testIndex}` : ''
        }`;
      },
      transformResponse: (response: any) => {
        return response;
      },
    }),
  }),
});
export const { useLazyGetBankIdSessionQuery, useGetBankIdSessionQuery } =
  intelligentServicesApi;
